import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Panels Module Service Stores
 */
export const panelsStores: ServiceStoreConfig[] = [
  {
    name: "panel",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      serviceView: {
        enableServiceView: true,
        summaryCards: (rootStore) => {
          const store = rootStore.panelStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalPanels = entities.length;
          const completedPanels = entities.filter(
            (panel: Record<string, unknown>) =>
              panel.status === "completed" || panel.status === "shipped"
          ).length;
          const inProductionPanels = entities.filter(
            (panel: Record<string, unknown>) =>
              panel.status === "in_production" || panel.status === "casting"
          ).length;
          const totalSquareFeet = entities.reduce(
            (sum: number, panel: Record<string, unknown>) => {
              const width = (panel.width as number) || 0;
              const height = (panel.height as number) || 0;
              return sum + (width * height) / 144; // Convert to square feet
            },
            0
          );

          return [
            {
              title: "Total Panels",
              value: () => totalPanels.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Completed",
              value: () => completedPanels.toString(),
              valueColor: "success.main",
            },
            {
              title: "In Production",
              value: () => inProductionPanels.toString(),
              valueColor: "warning.main",
            },
            {
              title: "Total Sq Ft",
              value: () => `${(totalSquareFeet as number).toFixed(0)}`,
              valueColor: "info.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
  {
    name: "panel-inventory",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
    },
  },
  // Panel additional services
  {
    name: "panel-additional-casting",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  // New backend service
  {
    name: "panel-remediation",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
];